(ns common.schema.entities.system-activity
  (:require [common.schema.schema-utils :as su]))

(def schema
  (concat
   (su/keyword-field :system-activity/type "Type" nil
                     {:authorization            su/access-system-user
                      :default-field-visibility :in-use-disabled
                      :system-semantics         su/system-controlled-optional-field-semantics})
   (su/single-ref-field :system-activity/target-stage "Target stage"
                        [:entity.type/stage]
                        {:authorization            su/access-system-user
                         :default-field-visibility :in-use-disabled
                         :system-semantics         su/system-controlled-optional-field-semantics})
   (su/single-ref-field :system-activity/pass-reason "Pass reason"
                        [:entity.type/named-value]
                        {:authorization            su/access-system-user
                         :default-field-visibility :in-use-disabled
                         :system-semantics         su/system-controlled-optional-field-semantics})
   (su/long-field :system-activity/on-hold-until "On hold until"
                  {:authorization            su/access-system-user
                   :default-field-visibility :in-use-disabled
                   :system-semantics         su/system-controlled-optional-field-semantics})
   (su/text-wysiwyg-field :system-activity/comment "Comment"
                          {:authorization            su/access-system-user
                           :default-field-visibility :in-use-disabled
                           :system-semantics         su/system-controlled-optional-field-semantics})
   #_(su/keyword-field :system-activity/move-direction "Move direction" nil
                       {:authorization            su/access-system-user
                        :default-field-visibility :in-use-disabled})
   (su/single-ref-field :system-activity/loss-reason "Loss reason"
                        [:entity.type/named-value]
                        {:authorization            su/access-system-user
                         :default-field-visibility :in-use-disabled
                         :system-semantics         su/system-controlled-optional-field-semantics})
   (su/text-edn-field :system-activity/info "Info"
                      {:authorization            su/access-system-user
                       :default-field-visibility :in-use-disabled
                       :system-semantics         su/system-controlled-optional-field-semantics})))
